import axios from "axios";
import { headers, jwt } from "./constants";
import * as yup from "yup";

export interface IUserSuburbSelection {
  id?: string;
  name?: string;
  ownerId?: string;
  sortOrder?: number;
}

export const userSuburbSelectionSchema = yup.object().shape({
  name: yup.string().nullable().required("Name is required"),
});

export let list = async (ownerId: string) => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/userSuburbSelection/list/", {
      headers: headers,
      params: { ownerId: ownerId },
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let get = async (id: string) => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/userSuburbSelection/get/", {
      headers: headers,
      params: { id: id },
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let create = async (userSuburbSelection: IUserSuburbSelection) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/userSuburbSelection/create",
      { data: userSuburbSelection },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let update = async (userSuburbSelection: IUserSuburbSelection) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/userSuburbSelection/update",
      { data: userSuburbSelection },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let deleteOne = async (userSuburbSelection: IUserSuburbSelection) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/userSuburbSelection/delete",
      { data: userSuburbSelection },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};
